import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import FieldStatus from '../field-status';
import TagInput from '../tag-input';

const defaultRules = {};

const TagInputField = ({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undef... Remove this comment to see the full error message
  name = null,
  control,
  rules = defaultRules,
  onChange = Function.prototype,
  onBlur = Function.prototype,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (newValue) => {
      field.onChange(newValue);
      onChange(newValue);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(() => {
    field.onBlur();
    onBlur();
  }, [field, onBlur]);

  return (
    <React.Fragment>
      <TagInput
        {...otherProps}
        name={field.name}
        tags={field.value}
        invalid={fieldState.invalid}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

export default TagInputField;
